var exports = {
  "k": "x24da60e8--e6d6be--container",
};

module.exports = exports;
